<!-- <div class="header-wrapper d-flex justify-content-between">
  <img src="https://images.5paisa.com/forum/icon-left-arrow.svg" (click)="goBack()" />
  <h3 class="m-0 font-16 fw-500">Create Ticket</h3>
  <div class="header-image-wrapper"> -->
    <!-- <img src="https://images.5paisa.com/forum/icon-language.png" /> -->
  <!-- </div>
</div> -->

<div class="main-wrapper crete-ticket-form">
  <h1 class="visually-hidden">Create Ticket</h1>
  <form [formGroup]="createTicketForm" novalidate>
    <p class="required-legend" id="required-legend"><span aria-hidden="true">*</span> indicates required fields</p>

    <mat-form-field floatLabel="always" [class.field-invalid]="isFieldInvalid('category')">
      <mat-label>Choose Problem Category</mat-label>
      <mat-select formControlName="category" (selectionChange)="selectFirstCategory($event.value)" placeholder="Select" required aria-required="true"
        [attr.aria-invalid]="isFieldInvalid('category')">
        <mat-option *ngFor="let item of mainBaseArray" [value]="item.name" (click)="showChild(item.name)" >{{item.name}}</mat-option>
      </mat-select>
      <mat-error *ngIf="isFieldInvalid('category')">
        <span class="error-icon" aria-hidden="true">!</span>
        Choose Problem Category is required
      </mat-error>
    </mat-form-field>

    <mat-form-field floatLabel="always" *ngIf="showSecondaryCategory" [class.field-invalid]="isFieldInvalid('subCategory')">
      <mat-label>Secondary Category</mat-label>
      <mat-select formControlName="subCategory" (selectionChange)="selectSecondCategory($event.value)" placeholder="Select" required aria-required="true"
        [attr.aria-invalid]="isFieldInvalid('subCategory')">
        <mat-option *ngFor="let item of childArray" (click)="frequentlyAskedQuestions(item.id)" [value]="item.name">{{item.name}}</mat-option>
      </mat-select>
      <mat-error *ngIf="isFieldInvalid('subCategory')">
        <span class="error-icon" aria-hidden="true">!</span>
        Secondary Category is required
      </mat-error>
    </mat-form-field>
  
    <mat-form-field floatLabel="always" [class.field-invalid]="isFieldInvalid('subject')">
      <mat-label>Subject</mat-label>
      <input matInput formControlName="subject" placeholder="Please fill the subject" (keypress)="omit_special_char($event)" required aria-required="true"
        [attr.aria-invalid]="isFieldInvalid('subject')">
      <mat-error *ngIf="isFieldInvalid('subject')">
        <span class="error-icon" aria-hidden="true">!</span>
        Subject is required
      </mat-error>
    </mat-form-field>

    <!-- <h3>Couldn't find help? continue with ticket!</h3> -->

    <mat-form-field floatLabel="always" [class.field-invalid]="isFieldInvalid('issueDescription')">
      <mat-label>Describe Your Issue In Detail</mat-label>
      <textarea
        matInput
        placeholder="Please attach a screenshot/image to help answer you better."
        formControlName="issueDescription" (keypress)="omit_special_char($event)"
        required aria-required="true"
        [attr.aria-invalid]="isFieldInvalid('issueDescription')"
      ></textarea>
      <mat-error *ngIf="isFieldInvalid('issueDescription')">
        <span class="error-icon" aria-hidden="true">!</span>
        Describe Your Issue In Detail is required
      </mat-error>
    </mat-form-field>
  </form>  

  <div class="upload-file">
    <div class="upload-wrapper">
      <img src="https://images.5paisa.com/forum/icon-upload.svg" alt="" aria-hidden="true" />

      <label class="custom-file-upload">
        <input type="file" #fileInput
          type="file"
          accept="image/jpg,
          image/jpeg,
          image/png,
          application/pdf,
          application/msword,
          application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          (change)="onFileSelected($event)"
        >
        <span *ngIf="isFileUploaded == false">
          Upload file
        </span>
        <span *ngIf="isFileUploaded == true">
          Upload new file
        </span>
    </label>
      <img src="https://images.5paisa.com/forum/icon-circle-check.svg" alt="File uploaded successfully" *ngIf="isFileUploaded"/>      
    </div>
    <p *ngIf="fileSizeError" class="field-error" role="alert" id="file-size-error">
      <span class="error-icon" aria-hidden="true">!</span>
      File size limit exceeded. Maximum file size is 5MB.
    </p>
    <p>Max file size: 5MB each</p>
    <p>Supported types: PNG, JPG, JPEG, PDF, DOC.</p>
  </div>

  <div class="faq-section" *ngIf="showFaq">
    <h1 class="main-heading font-18 font-500">Here are few FAQs that might help you</h1>
    <div class="accordian-wrapper">
      <ul *ngFor="let item of faqArray">
        <li tabindex="0"
          role="button"
          [attr.aria-label]="'Read FAQ: ' + item.title"
          (click)="goTosubCategoryAnswers(item.id, item.permalink, item.category.id)"
          (keydown)="onFaqKeydown($event, item.id, item.permalink, item.category.id)">
          <h2 class="label">{{item.title}}</h2>
          <span class="icon-right-chevron" aria-hidden="true"></span>
        </li>
      </ul>
    </div>
    <div class="faq-text-wrapper">
      <a *ngIf="showMore"
        class="text-link"
        href="javascript:;"
        (click)="goToSubCategory()"
        [attr.aria-label]="'View all FAQs for ' + (selectedSecondCategoryValue || selectedFirstCategoryValue)">
        View All FAQ's
      </a>
    </div>
  </div>
  
  <div class="bottom-button-wrapper">
    <button type="button" class="btn-primary" [disabled]="isButtonDisabled" (click)="checkValidationAndCreateTicket()">Create ticket</button>
  </div>
</div>
